// src/i18n/i18n-config.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Tes fichiers JSON de langues
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
    },
    lng: "en",          // langue par défaut
    fallbackLng: "en",  // langue de secours
    interpolation: {
      escapeValue: false, // recommandé pour React
    },
  });

export default i18n;
